import RenderIf from "common/components/RenderIf";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";
import { Tag } from "common/components/ui/Tag";

import { PROFILE_SEARCH_OPTIONS } from "../../../../../../../constants";
import useSearchOptions from "../../../../../../../datahooks/useSearchOptions";
import Followers from "../Options/Followers";
import GenericOptions from "../Options/GenericOptions";
import Languages from "../Options/Languages";
import useSearchParams from "../useSearchParams";

import type { JSX } from "react";

export default function SearchParamSelect({
  optionsKey,
}: {
  optionsKey: keyof typeof PROFILE_SEARCH_OPTIONS;
}) {
  // this helps load suggestions earlier
  useSearchOptions();
  const { appliedSearchParamValues } = useSearchParams(optionsKey);
  const { icon: Icon, label } = PROFILE_SEARCH_OPTIONS[optionsKey];

  let content: JSX.Element;
  if (optionsKey === "followers_of") {
    content = <Followers optionsKey={optionsKey} />;
  } else if (optionsKey === "languages") {
    content = <Languages optionsKey={optionsKey} />;
  } else {
    content = <GenericOptions optionsKey={optionsKey} />;
  }

  return (
    <AccordionItem value={optionsKey}>
      <AccordionTrigger className="h-10">
        <Icon size={20} weight="fill" />
        <span>{label}</span>
        <RenderIf condition={!!appliedSearchParamValues.length}>
          <Tag variant="primary-black">{appliedSearchParamValues.length}</Tag>
        </RenderIf>
      </AccordionTrigger>
      <AccordionContent className="px-1 py-2">{content}</AccordionContent>
    </AccordionItem>
  );
}
